<template>
  <div>
    <div style="width: 100%" :style="{ height: height }" :id="id"></div>
  </div>
</template>

<script>
import { getUUID } from '../../../utils/util'
import chartResize from '@/mixin/chart-resize'
export default {
  mixins: [chartResize],
  name: 'RingDiagram',
  components: {},
  data () {
    return {
      id: getUUID()
    }
  },
  myChart: null,
  unwatch: null,
  props: {
    pdata: {
      type: Object,
      default: () => { }
    },
    height: {
      type: String,
      default: '220px'
    }
  },
  methods: {
    drawRingGraph () {
      console.log('drawRingGraph===', this.pdata)
      const _this = this
      this.myChart = echarts2.init(document.getElementById(_this.id))
      this.unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set (data) {
      var option
      // let title = '总wg量'
      var data = this.pdata.PieChart
      option = {
        title: [
          {
            // text: '{name|' + title + '}\n{val|' + formatNumber(total) + '}',
            text: this.pdata.title,
            top: '40%',
            left: '20%',

            textStyle: {
              fontSize: 14,
              fontWeight: '600',
              color: '#666666',
              padding: [10, 0]
            }
          }
        ],
        color: this.pdata.color,
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            var allData = 0
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:5px;margin-bottom:0px;border-radius:7px;width:9px;height:7px;background:' +
              params.color +
              '"></span>'
            result += params.data.name + '<br>'
            result += '&nbsp&nbsp&nbsp数量 ：' + params.data.value + '个' + '<br>'
            return result
          }
        },
        legend: {
          left: '60%',
          top: '20%',
          orient: 'vertical', // 垂直显示
          // padding: 70, //调节legend的位置
          formatter: function (name) {
            // var total = 0
            var percentage
            var target
            for (var i = 0, l = data.length; i < l; i++) {
              //   total += data[i].value

              if (data[i].name == name) {
                target = data[i].value
                percentage = data[i].percentage
              }
            }
            var arr = ['{a|' + name + ' \n}' + target + '个']
            return arr.join('\n')
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 10,

                padding: [0, 0, 0, 0]
              },
              b: {
                fontSize: 10,

                padding: [2, 0, 0, 0],
                'letter-spacing': '0.48px',
                color: '#666666'
              }
            }
          }
        },
        series: [
          {
            center: ['30%', '45%'],
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.pdata.PieChart
          }
        ]
      }
      this.myChart.setOption(option)
      this.chartEleResizeListener()
    }
  },
  mounted () {
    this.drawRingGraph()
  },
  created () { },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (!this.myChart?.isDisposed) {
      this.myChart.dispose()
    }
  }
}
</script>
<style lang="less" scoped></style>
